<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>{{ category && category.id ? 'Update' : 'New' }} Form Category</h5>

  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    (click)="onClose()"
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<form #f="ngForm" (ngSubmit)="onSubmit(f)">

  <hr class="m-0 p-0">

  <mat-dialog-content class="px-3 py-4">
    <mat-form-field class="full-width" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Category</mat-label>
      <input
        matInput
        placeholder="Category"
        [(ngModel)]="category.category"
        name="category"
        type="text"
        id="category"
        required />
      <mat-hint>Enter a name for your category.</mat-hint>
    </mat-form-field>
  </mat-dialog-content>

  <hr class="m-0 p-0">

  <mat-dialog-actions class="d-flex justify-content-end px-3 py-2">
    <button
      mat-raised-button
      [disabled]="!f.valid"
      type="submit"
      class="my-2 ml-1 mr-2"
      color="primary">
      <mat-icon>save</mat-icon> Save
    </button>
    <button
      mat-raised-button
      [disabled]="!f.valid"
      type="button"
      class="my-2 mx-1"
      color="primary"
      (click)="onSubmit(f, true)">
      <mat-icon>save</mat-icon> Save & Close
    </button>
  </mat-dialog-actions>

</form>
